// This prototype accepts one or two arguments
// if the first one is a function, it is used as super
// otherwise it is used as prototype
Function.prototype.extend = function (_super, proto) {
  var hasSuper = typeof _super === "function",
    key;

  // There is a constructor to extend let do Intermediate stuff
  if (hasSuper) {
    function I() {}

    I.prototype = _super.prototype;
    this.prototype = new I();
  } else {
    // Super is not a function
    // we suppose this has been sent as prototype
    proto = _super;
  }

  if (proto) {
    // Assign every method from proto instance
    for (key in proto) {
      this.prototype[key] = proto[key];
    }

    // Some browser does not include constructor, toString, and valueOf keywords
    // inside a for in loop, even if these are explicitly declared
    if (proto.hasOwnProperty("toString")) {
      this.prototype.toString = proto.toString;
    }

    if (proto.hasOwnProperty("valueOf")) {
      this.prototype.valueOf = proto.valueOf;
    }
  }

  // If there is a super, we create
  // the prototype that will make magic happen
  if (hasSuper) {
    // This prototype accepts zero or more arguments
    // if the first argument is a nullable value (undefined, false, 0, "", null)
    // this function will call directly the constructor
    // while if name is a string, this function will call
    // super method with that name (if any, otherwise it will rightly raise an error)
    this.prototype._super = function (name) {
      var _rem = this._super,
        result;

      // To continue with inherited chain
      // the _super property has to be
      // setted as the one stored in parent constructor prototype
      this._super = _super.prototype._super;

      // This is because inside super method we would like to be able
      // to use again the magic _super with parent constructor or method as well
      result = (name ? _super.prototype[name] : _super).apply(
        this,
        Array.prototype.slice.call(arguments, 1)
      );

      // After constructor or parent method execution
      // we have to set the original super to be able
      // to call this method another time
      this._super = _rem;

      // Operation result
      return result;
    };
  }

  // Remember the correct constructor
  this.prototype.constructor = this;

  // To make things more simple, return the function itself
  return this;
};

var topics = {};

jQuery.Topic = function (id) {
  var callbacks,
    method,
    topic = id && topics[id];

  if (!topic) {
    callbacks = jQuery.Callbacks();
    topic = {
      publish: callbacks.fire,
      subscribe: callbacks.add,
      unsubscribe: callbacks.remove,
    };

    if (id) {
      topics[id] = topic;
    }
  }

  return topic;
};

function AjaxHandler(options) {
  var defaults = {
    delay: 500,
    start: function () {},

    success: function () {},

    error: function () {},
  };

  this.options = $.extend(defaults, options);
  this.call_running = 0;
}

AjaxHandler.prototype = {
  add: function (url, delay) {
    var _this = this;

    if (this.timer) {
      clearTimeout(this.timer);
    }

    var ctx = _this.options.start();

    this.timer = setTimeout(function () {
      _this.call(url, ctx);
    }, delay || _this.options.delay);

    return ctx;
  },

  add_get: function (url, data, delay) {
    var _this = this;

    if (this.timer) {
      clearTimeout(this.timer);
    }

    var ctx = _this.options.start();

    this.timer = setTimeout(function () {
      _this.call(url, ctx, data, "GET");
    }, delay || _this.options.delay);

    return ctx;
  },

  add_post: function (url, data, delay) {
    var _this = this;

    if (this.timer) {
      clearTimeout(this.timer);
    }

    var ctx = _this.options.start();

    this.timer = setTimeout(function () {
      _this.call(url, ctx, data);
    }, delay || _this.options.delay);

    return ctx;
  },

  call: function (url, ctx, data, method) {
    var _this = this;

    this.call_running += 1;
    var dfd;

    if (!data) {
      dfd = $.ajax({
        dataType: "json",
        cache: false, // Cache to false for IE8 and deliverydate handle
        url: url,
      });
    } else {
      dfd = $.ajax({
        dataType: "json",
        method: method || "POST",
        cache: false, // Cache to false for IE8 and deliverydate handle
        url: url,
        data: data,
      });
    }

    return dfd
      .done(function (data, textStatus, jqXHR) {
        if (data) {
          _this.options.success(data, ctx);
        }
        _this.call_running = 0;
      })
      .fail(function (jqXHR, textStatus) {
        if (jqXHR.status == 409 && _this.call_running == 1) {
          _this.add(url, 500);
        } else {
          _this.options.error(jqXHR, ctx);
        }
      });
  },
};

var Material = function (dict) {
  for (k in dict) {
    this[k] = dict[k];
  }
};

Material.prototype = {
  toString: function () {
    return "<Material " + this.slug + " id=" + this.id + ">";
  },

  getViewerMaterial: function (finish, painting, color) {
    finish =
      finish ||
      (typeof viewerUI != "undefined" && viewerUI && viewerUI.design.order
        ? viewerUI.design.order.finish
        : null);
    painting =
      painting ||
      (typeof viewerUI != "undefined" && viewerUI && viewerUI.design.order
        ? viewerUI.design.order.painting
        : null);
    color =
      color ||
      (typeof viewerUI != "undefined" && viewerUI && viewerUI.design.order
        ? viewerUI.design.order.color
        : null);
    if (
      window.sculpteo &&
      window.sculpteo.getMapValue &&
      window.materialOptionColors
    ) {
      var materialOptionColorIndex = window.sculpteo.getMapValue(
        this,
        finish,
        painting,
        null,
        color
      );
      if (materialOptionColorIndex in window.materialOptionColors) {
        var viewer_material =
          window.materialOptionColors[materialOptionColorIndex];
        viewer_material.ignore_override = true;
        return viewer_material;
      }
    }

    if (painting) {
      if (!$.isEmptyObject(window.paintings[painting].viewer_material)) {
        return window.paintings[painting].viewer_material;
      }
    }

    //if there is a finish and it is not smoothing beautifier (myrtillage)
    //return the viewer_material from the finished var.
    //new print :
    //templates/design/design.js line 26
    //old print :
    //templates/design/print.js line 33
    if (finish && (finish != "myrtillage" || finish != "chemical_smoothing")) {
      if (!$.isEmptyObject(window.finishes[finish].viewer_material)) {
        return window.finishes[finish].viewer_material;
      }
    }

    return this.viewer_material;
  },

  encoded: function (size, finish, painting, design, color) {
    var vm = this.getViewerMaterial(finish, painting, color);
    if (design) this.design = design;

    if (vm == null || $.isEmptyObject(vm) || !vm.ambient) {
      return { material: this.slug, smooth_normals: false, bumpnoise: "" };
    }

    var use_pbr = vm.use_pbr && this.slug != "clear_high_detailed_resin";
    var material_name = "white_plastic";
    var envmap = vm.envmap || use_pbr;
    var smooth = vm.smooth;

    if (use_pbr) {
      smooth = false;
    }

    if (!vm.color) {
      var ior = vm.ior;
      var mean_free_path = this.get_meanfreepath(size, finish, painting);

      if (use_pbr) {
        var roughness = vm.roughness;
        var fresnel0 = vm.fresnel0;
        var gloss = vm.gloss;
        var diffuse = color3f_to_html(
          vm.pbr_diffuse[0],
          vm.pbr_diffuse[1],
          vm.pbr_diffuse[2]
        ).substring(1);
        var specular = color3f_to_html(
          vm.pbr_specular[0],
          vm.pbr_specular[1],
          vm.pbr_specular[2]
        ).substring(1);

        material_name =
          "full_pbr_d" +
          diffuse +
          "_s" +
          specular +
          "_" +
          roughness +
          "_" +
          fresnel0 +
          "_" +
          gloss +
          "_" +
          ior +
          "_" +
          mean_free_path;
      } else {
        var ambient = color3f_to_html(
          vm.ambient[0],
          vm.ambient[1],
          vm.ambient[2]
        ).substring(1);
        var diffuse = color3f_to_html(
          vm.diffuse[0],
          vm.diffuse[1],
          vm.diffuse[2]
        ).substring(1);
        var specular = color3f_to_html(
          vm.specular[0],
          vm.specular[1],
          vm.specular[2]
        ).substring(1);
        var emissive = "000000";
        var transmit = color3f_to_html(
          vm.transmit[0],
          vm.transmit[1],
          vm.transmit[2]
        ).substring(1);
        var exponent = "" + vm.specular_exponent;

        if (
          this.design &&
          this.design.order &&
          (this.design.order.finish === "myrtillage" ||
            this.design.order.finish === "chemical_smoothing") &&
          !vm.ignore_override
        ) {
          envmap = true;
          smooth = false;
          exponent = "1000";
          diffuse = "727265";
          specular = "666666";
        }
        if (
          this.design &&
          this.design.order &&
          this.design.order.finish &&
          this.design.order.finish.match(/lunettes|outdoor/)
        ) {
          var p = this.design.order.finish.split("_")[1];
          var vm2 = this.getViewerMaterial(finish, "painting_" + p);
          ambient = color3f_to_html(
            vm2.ambient[0],
            vm2.ambient[1],
            vm2.ambient[2]
          ).substring(1);
          diffuse = color3f_to_html(
            vm2.diffuse[0],
            vm2.diffuse[1],
            vm2.diffuse[2]
          ).substring(1);
          specular = color3f_to_html(
            vm2.specular[0],
            vm2.specular[1],
            vm2.specular[2]
          ).substring(1);
          emissive = "000000";
          transmit = color3f_to_html(
            vm2.transmit[0],
            vm2.transmit[1],
            vm2.transmit[2]
          ).substring(1);
          exponent = "" + vm2.specular_exponent;
        }

        material_name =
          "full_a" +
          ambient +
          "_d" +
          diffuse +
          "_s" +
          specular +
          "_e" +
          emissive +
          "_t" +
          transmit +
          "_x" +
          exponent +
          "_i" +
          ior +
          "_l" +
          mean_free_path;
      }
    } else if (use_pbr) {
      var specular = color3f_to_html(
        vm.pbr_specular[0],
        vm.pbr_specular[1],
        vm.pbr_specular[2]
      ).substring(1);
      var ior = vm.ior;
      var mean_free_path = this.get_meanfreepath(size, finish, painting);
      var roughness = vm.roughness;
      var fresnel0 = vm.fresnel0;
      var gloss = vm.gloss;

      material_name =
        "full_pbr_dcolor0_s" +
        specular +
        "_" +
        roughness +
        "_" +
        fresnel0 +
        "_" +
        gloss +
        "_" +
        ior +
        "_" +
        mean_free_path;
    }

    return {
      material: material_name,
      envmap: envmap,
      smooth_normals: smooth,
      translucency: vm.translucency,
      gaussian_amplitude: this.get_gauss_amplitude(size, finish, painting),
      bumpnoise: this.get_bumpnoise(size, finish, painting),
    };
  },

  get_meanfreepath: function (size, finish, painting) {
    var viewer_material = this.getViewerMaterial(finish, painting);

    if (
      typeof viewer_material == "undefined" ||
      typeof viewer_material.mean_free_path == "undefined" ||
      viewer_material.mean_free_path == 0.0 ||
      !size
    ) {
      return 0.0;
    }

    var scale = size.designerScale * size.userScale * size.unitFactor() * 10;
    var mean_free_path = viewer_material.mean_free_path;
    var mfp = mean_free_path / scale;

    return mfp;
  },

  get_gauss_amplitude: function (size, finish, painting) {
    var viewer_material = this.getViewerMaterial(finish, painting);

    if (
      typeof viewer_material == "undefined" ||
      typeof viewer_material.gaussian_amplitude == "undefined" ||
      viewer_material.gaussian_amplitude == 0.0 ||
      !size
    ) {
      return 0;
    }

    var scale = size.scaleFactor();
    var maxd = Math.max(Math.max(size.x, size.y), size.z) * scale;

    if (maxd == 0) {
      return 0;
    }

    maxd = 1 - 1 / Math.pow(maxd, 2);

    return viewer_material.gaussian_amplitude * maxd;
  },

  get_bumpnoise: function (size, finish, painting) {
    var viewer_material = this.getViewerMaterial(finish, painting);

    if (
      typeof viewer_material == "undefined" ||
      typeof viewer_material.perlin_amplitude == "undefined" ||
      viewer_material.perlin_amplitude == 0.0 ||
      !size
    ) {
      return "";
    }

    var scale = size.scaleFactor();
    var maxd = size.x;

    if (size.y > maxd) {
      maxd = size.y;
    }

    if (size.z > maxd) {
      maxd = size.z;
    }

    if (maxd == 0) {
      return "";
    }

    maxd = maxd * scale;
    var grain_size = viewer_material.perlin_scale;
    var ps = scale / grain_size;
    var pa = viewer_material.perlin_amplitude * Math.sqrt(grain_size / maxd);

    return "perlin:" + pa + "," + ps;
  },

  get_solidity_threshold: function (size) {
    var scale = size.scaleFactor();
    var threshold = this.threshold / scale;

    return threshold;
  },

  get_all_options: function () {
    if (!this.options) {
      return [];
    }

    var options = this.options;

    var result = [{}];

    for (var i in options) {
      var seq = [];
      var newlist = [];

      if (i !== "finish") {
        continue;
      }

      for (var k in options[i]) {
        seq.push(k);
      }

      for (var j in result) {
        var sublist = result[j];

        for (k in seq) {
          var item = {};

          item[i] = seq[k];
          $.extend(item, sublist);
          newlist.push(item);
        }
      }

      result = newlist;
    }

    return result;
  },
};

function JSONMaterialtoMaterialString(mat) {
  var ambient = color3f_to_html(
    mat.ambient_r,
    mat.ambient_g,
    mat.ambient_b
  ).substring(1);
  var diffuse = color3f_to_html(
    mat.diffuse_r,
    mat.diffuse_g,
    mat.diffuse_b
  ).substring(1);
  var specular = color3f_to_html(
    mat.specular_r,
    mat.specular_g,
    mat.specular_b
  ).substring(1);
  var emissive = "000000";
  var transmit = color3f_to_html(
    mat.transmit_r,
    mat.transmit_g,
    mat.transmit_b
  ).substring(1);
  var ior = mat.ior;
  var exponent = "" + mat.specular_exponent;
  var mean_free_path = 0;

  material_str =
    "full_a" +
    ambient +
    "_d" +
    diffuse +
    "_s" +
    specular +
    "_e" +
    emissive +
    "_t" +
    transmit +
    "_x" +
    exponent +
    "_i" +
    ior +
    "_l" +
    mean_free_path;

  return material_str;
}

var DesignOperation = function (design, id, klass, data) {
  this.klass = klass;
  this.design = design;
  this.id = id;
  this.timer = false;
  this.params_stack = false;
  this.data = data;
};

DesignOperation.prototype = {
  modify: function (args, no_reload) {
    var old_data = {};
    var modif_type = 0;
    if (no_reload) {
      modif_type = 4;
    }
    if (this.data) {
      old_data = $.extend({}, this.data);
      $.extend(this.data, args);
    } else {
      this.data = $.extend({}, args);
    }

    var def = $.Deferred(),
      _this = this;

    $.when(this.design.fetch_operation()).done(function () {
      def.fail(function () {
        _this.data = old_data;
      });
      _this.design
        .modify_operation(_this.id, args, modif_type)
        .then(def.resolve, def.reject);
    });

    return def.promise();
  },

  lock_field: function (field, lock) {
    var def = $.Deferred();
    var url =
      URLS["x_lock_field"] +
      field +
      "?uuid=" +
      this.design.model_uuid +
      "&temp_id=" +
      this.id +
      "&locked=" +
      (lock ? "1" : "0");

    $.get(url, function () {
      def.resolve();
    });

    return def.promise();
  },

  clone: function () {
    var op = new DesignOperation();

    op.klass = this.klass;
    op.data = $.extend({}, this.data);

    return op;
  },

  remove: function () {
    return this.design.modify_operation(this.id, {}, 2);
  },
};

var DesignOperationTemplate = function (design, klass, data) {
  this._super(undefined, design, 0, klass);
  this.data = $.extend({}, data);
}.extend(DesignOperation, {
  modify: function (args) {
    $.extend(this.data, args);

    return $.Deferred().resolve();
  },

  create: function (class_id, locked_fields) {
    var deferred = $.Deferred(),
      _this = this;

    log(
      "create operation type=" +
        this.klass +
        ", values = " +
        concatObject(this.data)
    );

    return $.when(this.design.fetch_operation()).then(function () {
      var lf = [];

      for (var k in locked_fields) {
        if (locked_fields[k]) {
          lf.push(k);
        }
      }

      log("add locked fields: " + lf.join(","));
      _this.design.age++;
      args = { uuid: _this.design.model_uuid };
      $.extend(args, _this.data);
      var url = $.param.querystring(URLS["x_add_operation"], args);

      $.post(
        url,
        { id: class_id, locked_fields: lf.join(","), age: _this.design.age },
        function (data, textStatus, xhr) {
          if (data.error && data.error.id == 0) {
            instance_id = data.body.id;
            deferred.resolve(data, textStatus, xhr);
            _this.design.operations[data.body.id] = new DesignOperation(
              _this.design,
              data.body.id,
              data.body.type
            );
            $.Topic("operation-updated").publish(data);
            $.Topic("operation-added").publish(data.body);
          } else {
            deferred.reject({ error: "Could not add this customization" });
          }
        }
      );
    });
  },
});

var Design = function (dict) {
  this.noLazy = 0;
  this.material = null;
  this.information = null;
  this.dfd_fetch_operation = false;
  this.dfd_update_scale = false;
  this.dfd_update_material = false;
  this.empty_design = false;
  this.dfd_bbox = $.Deferred();
  this.dfd_groups = $.Deferred();
  this.notFoundHandler = null;
  this.asyncCallHandler = null;

  for (var k in dict) {
    this[k] = dict[k];
  }

  this.age = 0;
  this.operations = {};
  this.modify_queue = Array();
  this.list_wall_thickness = Array();
  this.list_wall_thickness.id = 0;
  this.is_configuration_mode = false;
  this.is_configuration_preview_mode = false;
  this.series = {
    positions: [],
    enabled: false,
    pack: 0,
    orientation: { w: NaN, x: NaN, y: NaN, z: NaN },
  };

  if (!this.empty_design && $.deparam) {
    this.model_uuid = $.deparam.querystring()["uuid"];

    if (!this.model_uuid) {
      this.model_uuid = $.deparam.fragment()["uuid"];
    }
  }
};

Design.prototype = {
  ajax_handle: function (call) {
    var dfd = $.Deferred();
    if (this.asyncCallHandler) {
      this.asyncCallHandler.apply(this, arguments);
    }
    call
      .done(
        function (data) {
          if (data === "Design not found" && this.notFoundHandler) {
            this.notFoundHandler.apply(this, arguments);
            dfd.reject.apply(this, arguments);
          } else {
            dfd.resolve.apply(this, arguments);
          }
        }.bind(this)
      )
      .fail(
        function (jqXHR) {
          if (jqXHR.status == 404 && this.notFoundHandler) {
            this.notFoundHandler.apply(this, arguments);
          }
          dfd.reject.apply(this, arguments);
        }.bind(this)
      );

    return dfd.promise();
  },

  get: function () {
    return this.ajax_handle(waitForJob.retryGetOnJob.apply(this, arguments));
  },

  getJSON: function () {
    return this.ajax_handle(
      waitForJob.retryGetJSONOnJob.apply(this, arguments)
    );
  },

  post: function () {
    return this.ajax_handle(waitForJob.retryPostOnJob.apply(this, arguments));
  },

  ajax: function () {
    return this.ajax_handle(waitForJob.retryAjaxOnJob.apply(this, arguments));
  },

  start_editing: function (force_save_new) {
    var _this = this;
    var url =
      URLS["x_design_detail_operations"] +
      (this.model_uuid ? this.model_uuid : "") +
      "?html=0" +
      (force_save_new ? "&force_save_new=1" : "");
    var dfd = $.Deferred();

    this.get(url)
      .done(function (data) {
        _this.model_uuid = data.uuid;
        var ops;

        if (data.body) {
          ops = data.body;
        } else {
          ops = data.operations;
        }

        _this.age = data.age;
        _this.name = data.name;
        _this.slug = data.slug;
        _this.parts_uuids = data.parts_uuids;
        _this.create_operation(ops, true);

        // _this.set_model_uuid(data.uuid);
        dfd.resolve();
      })
      .fail(function () {
        dfd.reject();
      });

    return dfd.promise();
  },

  clone: function () {
    var url =
      URLS["x_design_detail_operations"] +
      "?editinfo=" +
      this.model_uuid +
      "&html=0&nocache=" +
      new Date().getTime() +
      ((Math.random() * 0xffffff) | 0);
    var dfd = $.Deferred();
    var _this = this;

    this.get(url).done(function (data) {
      var new_d = new Design({
        parent: _this.parent,
        volume: _this.volume,
        design_uuid: _this.design_uuid,
      });

      // $.extend(true, new_d, _this);
      new_d.model_uuid = data.uuid;
      var ops;

      if (data.body) {
        ops = data.body;
      } else {
        ops = data.operations;
      }

      new_d.age = data.age;
      new_d.name = data.name;
      new_d.slug = data.slug;
      new_d.parts_uuids = data.parts_uuids;
      new_d.create_operation(ops, true);

      new_d.set_order(
        new Order({
          vat: _this.order.vat,
          quantity_discounts: [],
          mon_decimal_point: _this.order.mon_decimal_point,
          currency: _this.order.currency,
        })
      );

      for (var i = 0; i < _this.order.quantity_discounts.length; ++i) {
        var disc = $.extend({}, _this.order.quantity_discounts[i]);

        new_d.order.quantity_discounts.push(disc);
      }

      new_d.order.material_group_manager = new MaterialGroupManager(new_d);
      new_d.order.material_group_manager.design = new_d;
      new_d.order.materials = $.extend({}, _this.order.materials);

      for (var l in new_d.order.materials) {
        new_d.order.materials[l] = $.extend({}, new_d.order.materials[l]);
      }

      if (new_d.print_operation) {
        new_d.material =
          new_d.order.materials[new_d.print_operation.data.o_product];
      }

      new_d.size = _this.size.clone();
      new_d.center = {
        x: _this.center.x,
        y: _this.center.y,
        z: _this.center.z,
      };

      new_d.original_size = new_d.size.clone();

      $.Topic("design_cloned").publish(_this, new_d);

      // _this.set_model_uuid(data.uuid);
      dfd.resolve(new_d);
    });

    return dfd.promise();
  },

  get_information: function (version) {
    var _this = this;
    var dfd = $.Deferred();
    var v_param = "";
    if (version == 2) {
      v_param = "&version=2";
    }
    if (this.model_uuid) {
      var url =
        URLS["x_model_information"] + "?uuid=" + this.model_uuid + v_param;
    } else {
      var url =
        URLS["x_design_information"] +
        this.design_uuid +
        (version === 2 ? "?version=2" : "");
    }

    this.get(url)
      .done(function (data, textStatus, jqXHR) {
        _this.information = data;
        dfd.resolve(data);
      })
      .fail(function () {
        dfd.reject(this);
      });

    return dfd.promise();
  },

  get_warnings: function () {
    var _this = this;
    var dfd = $.Deferred();
    var url = URLS["x_message_warnings"] + "?uuid=" + this.model_uuid;

    this.get(url).done(function (data, textStatus, jqXHR) {
      if (jqXHR.status == 409) {
        _this.get_warnings().then(function (data) {
          dfd.resolve(data);
        });
      } else if (jqXHR.status == 200) {
        dfd.resolve(data);
      } else {
        dfd.reject();
      }
    });

    return dfd.promise();
  },

  update_material: function (material) {
    var _this = this,
      dfd = $.Deferred();

    if (!this.material || this.material.id != material.id) {
      $.when(this.fetch_operation(), this.dfd_update_scale)
        .pipe(function () {
          _this.print_operation.modify({ o_product: material.id });
          _this.material = material;
          $.Topic("material-selected").publish(material);
        })
        .then(function (data) {
          dfd.resolve(data);
        });

      this.dfd_update_material = dfd;

      return dfd.promise();
    }

    return dfd.reject({ info: "Material is the same" });
  },

  update_print_material: function (material, finish, painting) {
    if (
      !this.material ||
      this.material.id != material.id ||
      this.finish != finish ||
      this.painting != painting
    ) {
      return this.update_print_op(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        material,
        finish,
        painting
      );
    }

    var dfd = $.Deferred();

    return dfd.reject({ info: "Material is the same" });
  },

  select_design: function (design_uuid) {
    var dfd = $.Deferred();
    var me = this;

    $.when(this.fetch_operation()).then(function () {
      var url =
        URLS["designs_model_x_select_design"] +
        "?uuid=" +
        me.model_uuid +
        "&design_uuid=" +
        design_uuid;

      this.get(url).then(function () {
        dfd.resolve();
      });
    });

    return dfd.promise();
  },

  set_order: function (order) {
    this.order = order;
    order.design = this;
  },

  modify_operation: function (op_id, args, modif_type) {
    if (modif_type == null) {
      modif_type = 0;
    }

    if (modif_type == 0 && op_id == 0) {
      return;
    }

    // VCH/TODO: here we may ask the viewer to do the modification locally
    // this.operations[op_id] gives all the information on the current
    // operation state including class, data, etc...
    // args gives information on the modified data
    // viewer would set a dirty bit to prevent remote rendering while not in sync
    // with the server (which happens when modify queue has finished running)
    // console.log(args);
    // console.log(this.operations[op_id]);

    this.modify_queue.m = 1;

    // Try to find an item with the same instance_id
    var params = false;

    for (var i in this.modify_queue) {
      if (
        this.modify_queue[i].op_id != "" &&
        this.modify_queue[i].op_id == op_id
      ) {
        // Log("modifyOperation: found item for "+instance_id);
        params = this.modify_queue[i];
      }
    }

    if (!params) {
      // Log("modifyOperation: new item for "+instance_id);
      var dfd = $.Deferred();

      params = {
        op_id: op_id,
        modif_type: modif_type,
        no_lazy: this.noLazy,
        dfd: dfd,
      };
      this.modify_queue.push(params);
    }

    // Merge elements into queue item, for later call
    $.extend(params, args);

    // Log("modifyOperation: params for " + instance_id + ": " + concatObject(params));

    this.modify_queue.m = 0;

    if (this.modify_queue.timeout) {
      clearTimeout(this.modify_queue.timeout);
    }

    var me = this;

    this.modify_queue.timeout = setTimeout(function () {
      me.run_modify_queue();
    }, 750);

    return params.dfd.promise();
  },

  move_operation: function (op_id_list) {
    this.age++;
    var url =
      URLS["x_move_operation"] +
      "?uuid=" +
      this.model_uuid +
      "&no_lazy=" +
      this.noLazy;

    return this.post(url, { list: op_id_list, age: this.age }, function (data) {
      $.Topic("operation-moved").publish(op_id_list);
      $.Topic("operation-updated").publish(data);
    });
  },

  configuration_mode: function (enable) {
    var _this = this,
      dfd = $.Deferred();

    log("TODO: update operations of design");
    $.when(this.fetch_operation()).then(function () {
      var url;

      if (enable) {
        url = URLS["x_set_configurable_state"] + "?uuid=" + _this.model_uuid;
      } else {
        url = URLS["x_unset_configurable_state"] + "?uuid=" + _this.model_uuid;
      }

      dfd.resolve(
        this.post(url, { uuid: _this.model_uuid }, function (data) {
          if (data.error && data.error.id == 0) {
            _this.is_configuration_mode = enable;
            $.Topic("operation-reloaded").publish(data);
          }
        })
      );
    });

    return dfd.promise();
  },

  configuration_preview_mode: function (enable) {
    this.is_configuration_preview_mode = enable;
  },

  run_modify_queue: function () {
    if (this.modify_queue.timeout) {
      clearTimeout(this.modify_queue.timeout);
      this.modify_queue.timeout = false;
    }

    if (this.modify_queue.length == 0) {
      // Log("run_modify_queue: nothing to do");
      // VCH/TODO: here we can tell the viewer it is allowed to render again
      return;
    }

    var me = this;

    if (this.modify_queue.m == 1) {
      // Log("run_modify_queue: wait...");
      setTimeout(function () {
        me.run_modify_queue();
      }, 150);

      return;
    }

    var params = this.modify_queue.shift();
    var op_id = params.op_id;

    delete params.op_id;
    var dfd = params.dfd;

    delete params.dfd;
    var modif_type = params.modif_type;

    delete params.modif_type;

    var need_html = true;
    if (typeof params.need_html !== "undefined") {
      need_html = params.need_html;
      delete params.need_html;
    }

    if (params.hasOwnProperty("no_lazy")) {
      var noLazy = params.no_lazy;
    } else {
      var noLazy = this.noLazy;
    }

    // Log("run_modify_queue: params: "+concatObject(params));
    me.age++;

    switch (modif_type) {
      case 0:
        var ret = me.do_op_update(op_id, params);

        break;
      case 1:
        var ret = me.do_op_add(params, need_html, noLazy);

        break;
      case 2:
        var ret = me.do_op_delete(op_id, noLazy);

        break;
      case 3:
        var ret = me.do_load_in_viewer(params);

        break;
      // update without reloading the mesh
      case 4:
        var ret = me.do_op_update(op_id, params);

        break;
      default:
        var ret = $.Deferred();

        ret.reject();
        break;
    }

    ret
      .done(function (data, textStatus, jqXHR) {
        if (modif_type == 0) {
          if (data.age > me.age) {
            me.age = data.age;
          }
        }
        if (data.job) {
          job = sculpteoJob([data.job]);
          job.success(function (job, msg) {
            dfd.resolve(data, textStatus, jqXHR);
          });
          job.failure(function (job, msg) {
            dfd.reject(data, textStatus, jqXHR);
          });
        } else {
          dfd.resolve(data, textStatus, jqXHR);
        }

        // VCH/TODO: here we could patch data.update_geometry/update_material
        // if viewer was able to handle the operation modification locally; this way
        // no real load is triggered and a new render is made instead
        if (modif_type == 0) {
          $.Topic("operation-updated").publish(data);
          $.Topic("operation-modified").publish(
            me.operations[op_id],
            params,
            data
          );
        }
      })
      .fail(function (data, textStatus, jqXHR) {
        dfd.reject(data, textStatus, jqXHR);
      })
      .always(function () {
        me.run_modify_queue();
      });

    return ret;
  },

  do_op_update: function (op_id, params) {
    // no_lazy is already in params
    var post_url =
      URLS["x_modify_operation"] +
      "?uuid=" +
      this.model_uuid +
      "&temp_id=" +
      op_id +
      "&age=" +
      this.age;

    return this.ajax({
      type: "POST",
      url: post_url,
      data: params,
      cache: false,
    });
  },

  do_op_add: function (params, need_html, noLazy) {
    var me = this;
    var dfd = $.Deferred();
    var url =
      URLS["x_add_operation"] +
      (this.model_uuid ? "?uuid=" + this.model_uuid + "&age=" + this.age : "") +
      "&html=" +
      (need_html ? "1" : "0") +
      "&no_lazy=" +
      noLazy;

    this.post(url, params)
      .done(function (data) {
        if (!data.body) {
          dfd.reject(data);

          return;
        }

        me.create_operation([data.body], true);
        var op = me.operations[data.body.id];
        if (data.job) op.job = data.job;

        $.when(me.fetch_operation(true, need_html)).then(function () {
          dfd.resolve(op);
        });
      })
      .fail(function () {
        dfd.reject.apply(this, arguments);
      });

    return dfd.promise();
  },

  do_op_delete: function (op_id, noLazy) {
    this.age++;
    var url =
        URLS["x_remove_operation"] +
        "?uuid=" +
        this.model_uuid +
        "&no_lazy=" +
        noLazy,
      _this = this;

    return this.post(url, { temp_id: op_id, age: this.age }, function () {
      delete _this.operations[op_id];
      $.Topic("operation-removed").publish();
      $.Topic("operation-updated").publish();
    });
  },

  do_load_in_viewer: function (params) {
    var dfd = $.Deferred();
    var modelNode = params.viewer.getNodesByName(params.node)[0];
    if (!modelNode) {
      dfd.reject({});
      return dfd.promise();
    }
    var onBbox = function (minx, miny, minz, maxx, maxy, maxz) {
      modelNode.removeEventListener("load", onBbox);
      var bb_coords = [
        parseFloat(minx),
        parseFloat(miny),
        parseFloat(minz),
        parseFloat(maxx),
        parseFloat(maxy),
        parseFloat(maxz),
      ];

      if (!this.size) {
        this.size = new Size(0, 0, 0);
      }

      this.size.x = bb_coords[3] - bb_coords[0];
      this.size.y = bb_coords[4] - bb_coords[1];
      this.size.z = bb_coords[5] - bb_coords[2];
      this.size.bbox = bb_coords;
      this.size.min = { x: bb_coords[0], y: bb_coords[1], z: bb_coords[2] };
      this.size.max = { x: bb_coords[3], y: bb_coords[4], z: bb_coords[5] };
      this.center = {
        x: 0.5 * (bb_coords[3] + bb_coords[0]),
        y: 0.5 * (bb_coords[4] + bb_coords[1]),
        z: 0.5 * (bb_coords[5] + bb_coords[2]),
      };
      params.dfd_bbox.resolve(bb_coords);
    }.bind(this);

    modelNode.addEventListener("bbox", onBbox);

    var onGroups = function (groups) {
      groups = groups.split(",");
      this.groups = groups;
      params.dfd_groups.resolve(groups);
    }.bind(this);

    modelNode.addEventListener("groups", onGroups);

    var onLoad = function (val) {
      modelNode.removeEventListener("load", onLoad);
      modelNode.viewer.unbind("nodeloaded", onLoad);
      dfd.resolve(val);
    };
    var onLoadNode = function (id) {
      if (modelNode.id === id) {
        modelNode.removeEventListener("load", onLoad);
        modelNode.viewer.unbind("nodeloaded", onLoadNode);
        dfd.resolve("100");
      }
    };

    modelNode.addEventListener("load", onLoad);
    modelNode.viewer.bind("nodeloaded", onLoadNode);
    setTimeout(
      params.viewer.loadModel(
        this.model_src(params.allow_viewerfile),
        params.node
      ),
      0
    );

    return dfd.promise();
  },

  load_in_viewer: function (viewer, node, allow_viewerfile) {
    if (!node || node == "") {
      node = "model";
    }

    this.dfd_bbox = $.Deferred();
    this.dfd_groups = $.Deferred();

    var args = {
      viewer: viewer,
      node: node,
      url: this.model_url(),
      allow_viewerfile: allow_viewerfile || false,
      dfd_bbox: this.dfd_bbox,
      dfd_groups: this.dfd_groups,
    };

    return this.modify_operation("", args, 3);
  },

  /**
   * Returns a deferred object that is evaluated when the bbox is available
   */
  on_bbox: function () {
    return this.dfd_bbox.promise();
  },

  set_model_uuid: function (uuid) {
    this.model_uuid = uuid;
    if ($.deparam) {
      var old_uuid = $.deparam.querystring(window.location.href)["uuid"];

      if (window.history.replaceState) {
        if (!$.deparam.querystring()["uuid"] || old_uuid !== uuid) {
          window.history.replaceState(
            {},
            document.title,
            $.param.querystring(window.location.href, { uuid: uuid })
          );
        }
      } else {
        if (!$.deparam.fragment()["uuid"]) {
          window.location.replace(
            $.param.fragment(window.location.href, "uuid=" + uuid)
          );
        }
      }
    }
  },

  reload_operations: function () {
    var _this = this;
    var url =
      URLS["x_design_detail_operations"] +
      (this.design_uuid ? this.design_uuid : "") +
      "?html=0" +
      (this.model_uuid ? "&uuid=" + this.model_uuid : "");

    return this.get(url).done(function (data, textStatus, jqXHR) {
      if (!_this.model_uuid) {
        _this.set_model_uuid(data.uuid);
      }

      var ops;

      if (data.body) {
        ops = data.body;
      } else {
        ops = data.operations;
      }

      for (k in ops) {
        var o = ops[k];

        if (!_this.operations[o.id]) {
          operation = new DesignOperation(_this, o.id, o.type);
          _this.operations[o.id] = operation;
          var $op = $(o["long"]);

          operation.data = $op.data("operation");
        }
      }

      $.Topic("operation-reloaded").publish(data);
    });
  },

  fetch_operation: function (fill_operation_data, need_html, urlId) {
    if (this.dfd_fetch_operation) {
      return this.dfd_fetch_operation;
    }

    var url = "";
    var that = this;
    var dfd = $.Deferred();

    this.dfd_fetch_operation = dfd;

    if (need_html === undefined) {
      need_html = true;
    }
    if (!urlId) {
      urlId = "x_design_detail_operations";
    }

    var url =
      URLS[urlId] +
      (this.design_uuid ? this.design_uuid : "") +
      "?html=" +
      (need_html ? "1" : "0") +
      (this.model_uuid ? "&uuid=" + this.model_uuid : "");

    this.get(url)
      .done(function (data, textStatus, jqXHR) {
        if (!that.model_uuid) {
          that.set_model_uuid(data.uuid);
        }

        var ops;

        if (data.body) {
          ops = data.body;
        } else {
          ops = data.operations;
        }

        that.age = data.age;
        that.name = data.name;
        that.slug = data.slug;
        that.parts_uuids = data.parts_uuids;
        that.create_operation(ops, fill_operation_data);
        $.Topic("operation-fetched").publish(data);
        that.is_configuration_mode = data.is_configured;
        dfd.resolve(data, textStatus, jqXHR);
      })
      .fail(
        function () {
          dfd.reject.apply(this, arguments);
        }.bind(this)
      );

    return dfd.promise();
  },

  create_operation: function (ops, fill_operation_data) {
    for (var k in ops) {
      var o = ops[k],
        operation = new DesignOperation(this, o.id, o.type);

      this.operations[o.id] = operation;

      if (fill_operation_data) {
        var $op = $(o["long"]);

        operation.data = $op.data("operation");

        if (!operation.data && o.data) {
          operation.data = o.data;
        }
      }

      if (o.type == "PrintDesignOperation") {
        this.print_operation = this.operations[o.id];
        this.print_update_params = {};
        this.print_op_timer = null;
      }

      operation.seq = o.seq;
    }
  },

  get_operation_by_seq: function (seq) {
    for (var i in this.operations) {
      if (this.operations[i].seq == seq) {
        return this.operations[i];
      }
    }
  },

  get_operation: function (klass) {
    for (var i in this.operations) {
      if (this.operations[i].klass == klass) {
        return this.operations[i];
      }
    }
  },

  save_operations: function (opts) {
    var defaults = { uuid: this.model_uuid };

    if (opts) {
      $.extend(defaults, opts);
    }

    var that = this;

    return this.getJSON(URLS["x_save_operations"], defaults).then(function (
      data
    ) {
      that.uuid = data.uuid;
    });
  },

  update_scale: function (scale, unit, size_id, pack, orientation) {
    var d = {},
      _this = this,
      dfd = $.Deferred(),
      update = false;

    if (scale) {
      update |= this.size.userScale != scale;
      this.size.userScale = scale;
      d["scale"] = scale;
    }

    if (unit && this.size.unit != unit) {
      update |= this.size.unit != unit;
      this.size.unit = unit;
      d["unit"] = unit;
    }

    if (size_id) {
      update |= this.size.size_id != size_id;
      this.size.size_id = size_id;
      d["o_size_constraint"] = size_id;
    }

    if (typeof pack != "undefined") {
      update |= this.series.pack != pack;
      this.series.pack = pack;
      d["pack"] = pack;
    }

    if (typeof orientation != "undefined") {
      update |= this.series.orientation != orientation;
      this.series.orientation = orientation;
      d["orientation_w"] = orientation ? orientation.w : null;
      d["orientation_x"] = orientation ? orientation.x : null;
      d["orientation_y"] = orientation ? orientation.y : null;
      d["orientation_z"] = orientation ? orientation.z : null;
    }

    if (update) {
      $.when(this.fetch_operation(), this.dfd_update_material)
        .pipe(function () {
          _this.print_operation.modify(d);
          $.Topic("scale-changed").publish(_this.size, d);
        })
        .then(function (data) {
          dfd.resolve(data);
        });

      _this.dfd_update_scale = dfd;

      return dfd.promise();
    } else {
      return dfd.reject({ info: "Size is the same" });
    }
  },

  set_material: function (material) {
    if (!material) {
      this.material = undefined;
      return;
    }
    // Wrapper to always point to the appropriate material object in the order materials of this design
    if (
      this.order &&
      this.order.materials &&
      this.order.materials[material.id]
    ) {
      this.material = this.order.materials[material.id];
    } else {
      this.material = material;
    }
  },

  update_print_op: function (
    scale,
    unit,
    size_id,
    pack,
    orientation,
    material,
    finish,
    painting,
    options,
    quantity,
    color
  ) {
    // Update self and all parts
    var parts = this.partitioning
      ? [this].concat(this.partitioning.parts)
      : [this];
    var dfds = [];

    for (var k = 0; k < parts.length; k++) {
      var part = parts[k];

      dfds.push(
        part._update_print_op(
          scale,
          unit,
          size_id,
          pack,
          orientation,
          material,
          finish,
          painting,
          options,
          quantity,
          color
        )
      );
    }

    return $.when.apply(null, dfds);
  },

  _update_print_op: function (
    scale,
    unit,
    size_id,
    pack,
    orientation,
    material,
    finish,
    painting,
    options,
    quantity,
    color
  ) {
    var d = {},
      old_data = {},
      _this = this,
      dfd = $.Deferred(),
      update = false;

    if (scale) {
      old_data["scale"] = this.size.userScale;
      var local_scale = scale * (this.scale ? this.scale : 1.0);

      update |= this.size.userScale != local_scale;
      this.size.userScale = local_scale;
      d["scale"] = local_scale;
    }

    if (unit && this.size.unit != unit) {
      old_data["unit"] = this.size.unit;
      update |= this.size.unit != unit;
      this.size.unit = unit;
      d["unit"] = unit;
    }

    if (size_id) {
      old_data["o_size_constraint"] = this.size.size_id;
      update |= this.size.size_id != size_id;
      this.size.size_id = size_id;
      d["o_size_constraint"] = size_id;
    }

    if (typeof pack != "undefined") {
      old_data["pack"] = this.series.pack;
      update |= this.series.pack != pack;
      this.series.pack = pack;
      d["pack"] = pack;
    }

    if (typeof orientation != "undefined") {
      old_data["orientation"] = this.series.orientation;
      update |= this.series.orientation != orientation;
      this.series.orientation = orientation;
      d["orientation_w"] = orientation ? orientation.w : null;
      d["orientation_x"] = orientation ? orientation.x : null;
      d["orientation_y"] = orientation ? orientation.y : null;
      d["orientation_z"] = orientation ? orientation.z : null;
    }

    if (material && typeof material != "undefined") {
      if (!this.material || this.material.id != material.id) {
        old_data["o_product"] = this.material;
        update |= true;
        this.set_material(material);
        if (material.product_id) {
          d["o_product"] = material.product_id;
        } else {
          d["o_product"] = material.id;
        }
      }
    }

    if (
      this.finish != finish ||
      this.painting != painting ||
      this.color != color
    ) {
      update |= true;
      d["options"] = "";
    }

    if (finish || painting || color) {
      var opts = [];

      if (finish) {
        old_data["finish"] = this.finish;
        update |= this.finish != finish;
        this.finish = finish;
        opts.push(this.finish);
      }
      if (painting) {
        old_data["painting"] = this.painting;
        update |= this.painting != painting;
        this.painting = painting;
        opts.push(this.painting);
      }
      // The color of a material sold in several ones is an option of its own:
      // without it the print operation cannot tell which combination was
      // selected, every color of a material sharing the same infill.
      if (color) {
        old_data["color"] = this.color;
        update |= this.color != color;
        this.color = color;
        opts.push(this.color);
      }

      d["options"] = opts.join(",");
    }

    if (options && options.length > 0) {
      d["options"] = options.join(",");
      var unchanged =
        this.options === options ||
        (this.options === undefined && options.length == 0) ||
        (this.options && this.options.length == 0 && options.length == 0);
      update |= !unchanged;
    }

    if (quantity) {
      d["quantity"] = quantity;
      update = true;
    }

    if (update) {
      $.extend(this.print_update_params, d);

      if (this.print_op_timer) {
        clearTimeout(this.print_op_timer);
      }

      this.print_op_timer = setTimeout(function () {
        _this.print_op_timer = null;
        var params = _this.print_update_params;

        _this.print_update_params = {};
        $.when(_this.dfd_update_material).then(function () {
          _this.print_operation.modify(params).then(dfd.resolve, dfd.reject);
        });
      }, 0);

      _this.dfd_update_scale = dfd;

      dfd.fail(
        function () {
          if (old_data.hasOwnProperty("scale")) {
            this.size.userScale = old_data["scale"];
          }
          if (old_data.hasOwnProperty("unit")) {
            this.size.unit = old_data["unit"];
          }

          if (old_data.hasOwnProperty("o_size_constraint")) {
            this.size.size_id = old_data["o_size_constraint"];
          }
          if (old_data.hasOwnProperty("pack")) {
            this.series.pack = old_data["pack"];
          }
          if (old_data.hasOwnProperty("orientation")) {
            this.series.orientation = old_data["orientation"];
          }
          if (old_data.hasOwnProperty("o_product")) {
            this.set_material(old_data["o_product"]);
          }
          if (old_data.hasOwnProperty("finish")) {
            this.finish = old_data["finish"];
          }
          if (old_data.hasOwnProperty("painting")) {
            this.painting = old_data["painting"];
          }
        }.bind(this)
      );

      return dfd.promise();
    } else {
      return dfd.reject({ info: "Print parameters are the same" });
    }
  },

  is_print_op_updating: function () {
    return !this.dfd_update_scale
      ? false
      : this.dfd_update_scale.state() === "pending";
  },

  update_parts: function (to_add, to_remove) {
    var post_data = {
      add: to_add.join(","),
      remove: to_remove.join(","),
    };
    var url = URLS["x_modify_ensemble"] + "?uuid=" + this.model_uuid;

    return this.post(url, post_data);
  },

  model_url: function () {
    return URLS["x_refresh_model"] + "?uuid=" + this.model_uuid;
  },

  // Used to retreive the src structure used by the viewer
  model_src: function (allow_viewerfile) {
    if (!this.model_uuid && allow_viewerfile && this.information.src) {
      return this.information.src;
    } else {
      return this.model_url();
    }
  },

  get_face_index: function (x, y, z, dx, dy, dz, transform) {
    var v = [x, y, z, 1];

    v = transform.inverse().x(v);

    return this.get(URLS["design_get_face_index"], {
      uuid: this.model_uuid,
      position_x: v[0],
      position_y: v[1],
      position_z: v[2],
      direction_x: dx,
      direction_y: dy,
      direction_z: dz,
    });
  },

  measure_wall_thickness: function (x, y, z, dx, dy, dz, transform) {
    var that = this;

    this.list_wall_thickness.id += 1;
    var params = {
      type: "add",
      state: this.list_wall_thickness.state,
      x: x,
      y: y,
      z: z,
      dx: dx,
      dy: dy,
      dz: dz,
      part: this,
      transform: transform,
      dfd: $.Deferred(),
    };

    this.list_wall_thickness.push(params);
    $.when(this.fetch_operation(undefined, false)).then(function () {
      that.run_list_queue();
    });

    return params.dfd.promise();
  },

  delete_wall_thickness: function (x, y, z, dx, dy, dz, transform) {
    var that = this;

    var params = {
      type: "delete",
      state: 0,
      x: x,
      y: y,
      z: z,
      dx: dx,
      dy: dy,
      dz: dz,
      dfd: $.Deferred(),
    };

    this.list_wall_thickness.push(params);
    $.when(this.fetch_operation()).then(function () {
      that.run_list_queue();
    });

    return params.dfd.promise();
  },

  run_list_queue: function (force) {
    var that = this;

    // If a list is allready in process
    if (this.list_wall_thickness.state == 1 && !force) {
      return;
    }

    // If list is empty
    if (this.list_wall_thickness.length == 0) {
      return;
    }

    this.list_wall_thickness.state = 1;
    var params = this.list_wall_thickness.shift();

    var ret = this.update_measure(params, that.model_uuid);

    ret
      .done(function (data, textStatus, jqXHR) {
        if (!data.pos) {
          if (params.dfd) {
            params.dfd.reject(data);
          }
          return;
        }

        if (params.transform) {
          // In case of partitioning the part has a transformation
          // but the pos was requested in the local axis sytem
          // transform it back
          data.pos.push(1);
          data.pos = params.transform.x(data.pos);
          data.pos.splice(3, 1);
          var comp = params.transform.decompose();
          data.distance *= comp.scale;
        }

        if (params.dfd) {
          params.dfd.resolve(data);
        }
        $.Topic("wall-thickness-updated").publish(data, params);
      })
      .fail(function (data, textStatus, jqXHR) {
        if (params.dfd) {
          params.dfd.reject(data);
        }
      })
      .always(function () {
        if (that.list_wall_thickness.length) {
          that.run_list_queue(true);
        } else {
          that.list_wall_thickness.state = 0;
        }
      });

    return ret;
  },

  measure_distance: function (points) {
    return this.ajax({
      type: "GET",
      url: URLS["x_measure_distance"] + this.design_uuid,
      data: {
        uuid: this.model_uuid,
        position_x1: points[0][0],
        position_y1: points[0][1],
        position_z1: points[0][2],
        direction_x1: points[0][3],
        direction_y1: points[0][4],
        direction_z1: points[0][5],
        position_x2: points[1][0],
        position_y2: points[1][1],
        position_z2: points[1][2],
        direction_x2: points[1][3],
        direction_y2: points[1][4],
        direction_z2: points[1][5],
      },
    });
  },

  get_measurements: function () {
    return this.ajax({
      type: "GET",
      url: URLS["x_measurements"] + this.design_uuid,
      data: {
        uuid: this.model_uuid,
      },
    });
  },

  save_measurement: function (measurement) {
    var data = Object.assign({}, measurement);
    data.uuid = this.model_uuid;
    return this.ajax({
      type: "POST",
      url: URLS["x_measurements"] + this.design_uuid,
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(data),
    });
  },

  delete_measurement: function (pk) {
    return this.ajax({
      type: "DELETE",
      url: URLS["x_measurements"] + this.design_uuid + "/" + pk,
      data: {
        uuid: this.model_uuid,
      },
    });
  },

  update_measurement_title: function (pk, title) {
    var data = { uuid: this.model_uuid, title: title };
    return this.ajax({
      type: "PUT",
      url: URLS["x_measurements"] + this.design_uuid + "/" + pk,
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(data),
    });
  },

  update_measure: function (params, uuid) {
    var v = [params.x, params.y, params.z, 1];

    if (params.transform) {
      v = params.transform.inverse().x(v);
    }

    if (params.type == "add") {
      return this.ajax({
        type: "GET",
        url: URLS["x_measure_wall_thickness"],
        data: {
          uuid: uuid,
          position_x: v[0],
          position_y: v[1],
          position_z: v[2],
          direction_x: params.dx,
          direction_y: params.dy,
          direction_z: params.dz,
        },
      });
    }

    if (params.type == "delete") {
      return this.ajax({
        type: "GET",
        url: URLS["x_delete_wall_thickness"],
        data: {
          uuid: uuid,
          position_x: v[0],
          position_y: v[1],
          position_z: v[2],
          direction_x: params.dx,
          direction_y: params.dy,
          direction_z: params.dz,
        },
      });
    }
  },

  getFeaturesSelectedDimensions: function (set) {
    var data = {};
    data.uuid = this.model_uuid;
    data.selected = set;
    return this.ajax({
      type: "POST",
      url: URLS["x_features_selection"] + this.design_uuid,
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(data),
    });
  },

  get_local_thickness_minima: function () {
    var dfd = $.Deferred();
    var solidity = this.material.get_solidity_threshold(this.size);
    var url =
      URLS["local_thickness_minima"] +
      this.uuid +
      "?thickness_threshold=" +
      1.2 * solidity +
      (this.model_uuid ? "&uuid=" + this.model_uuid : "");
    this.get(url).done(
      function (data) {
        if (data.pos) {
          this.thin_points = data;
          for (var i = 0; i < this.thin_points.minima.length; ++i) {
            this.thin_points.minima[i].push(this.thin_points.pos[i]);
          }
          dfd.resolve(this.thin_points);
        }
        dfd.resolve();
      }.bind(this)
    );
    return dfd.promise();
  },

  series_place_in_box: function (qty, printer) {
    var that = this;
    var dfd = $.Deferred();

    $.when(this.fetch_operation()).then(function () {
      var scale =
        that.size.designerScale * that.size.userScale * that.size.unitFactor();

      this.ajax({
        type: "GET",
        url: URLS["x_series_place_in_box"],
        data: {
          uuid: that.model_uuid,
          quantity: qty,
          printer: printer,
          scale: scale,
        },
      })
        .success(function (data, textStatus, jqXHR) {
          dfd.resolve(data);
          $.Topic("series-box-updated").publish(qty, printer, data);
        })
        .error(function (data, textStatus, jqXHR) {
          dfd.reject(data);
        });
    });

    return dfd.promise();
  },

  create_csg: function (args) {
    var me = this;

    this.dfd_fetch_operation = $.Deferred();
    this.post(URLS["x_create_csg"], args)
      .done(function (data) {
        log("data = ");
        log(data);
      })
      .done(function (data) {
        me.model_uuid = data.uuid;
        me.create_operation(data.design.difflist);
        me.dfd_fetch_operation.resolve();
      });

    return this.dfd_fetch_operation.promise();
  },

  add_operation: function (args) {
    return this.modify_operation("", args, 1);
  },

  create_text: function (args) {
    var me = this;

    this.dfd_fetch_operation = $.Deferred();
    this.ajax(URLS["x_create_text"]).done(function (data) {
      me.model_uuid = data.uuid;
      me.create_operation(data.design.difflist);
      me.get_operation("TextDesignOperation").data = data.design.difflist[0];

      if (args) {
        $.when(
          me.do_op_update(me.get_operation("TextDesignOperation").id, args)
        ).then(function () {
          me.dfd_fetch_operation.resolve();
        });
      } else {
        me.dfd_fetch_operation.resolve();
      }
    });

    return this.dfd_fetch_operation.promise();
  },

  create_geometry: function (args) {
    var me = this;

    this.dfd_fetch_operation = this.ajax(URLS["x_create_geometry"]).done(
      function (data) {
        me.model_uuid = data.uuid;
        me.create_operation(data.design.difflist);
        me.get_operation("GeometryDesignOperation").data =
          data.design.difflist[0];
      }
    );

    return this.dfd_fetch_operation;
  },

  create_demo_materials: function (args) {
    var me = this;

    this.dfd_fetch_operation = this.ajax(URLS["x_create_demo_materials"]).done(
      function (data) {
        me.model_uuid = data.uuid;
      }
    );

    return this.dfd_fetch_operation;
  },

  create_hollow: function (args) {
    var me = this;
    var url =
      URLS["x_create_hollow"] +
      (this.model_uuid ? "?uuid=" + this.model_uuid : "");

    this.dfd_fetch_operation = this.ajax(url).done(function (data) {
      // Me.model_uuid = data.uuid;
      me.set_model_uuid(data.uuid);
      me.create_operation(data.design.difflist);
      me.get_operation("HollowDesignOperation").data = data.design.difflist[0];
      me.get_operation("ScriptOperation").data = data.design.difflist[1];
    });

    return this.dfd_fetch_operation;
  },

  create_cubify: function (args) {
    var me = this;

    this.dfd_fetch_operation = this.ajax(URLS["x_create_cubify"]).done(
      function (data) {
        me.model_uuid = data.uuid;
        me.create_operation(data.design.difflist);
        me.get_operation("CubifyDesignOperation").data =
          data.design.difflist[0];
      }
    );

    return this.dfd_fetch_operation;
  },

  create_extrusion: function (args) {
    var me = this;

    this.dfd_fetch_operation = $.Deferred();
    this.ajax(URLS["x_create_extrusion"]).done(function (data) {
      me.model_uuid = data.uuid;
      me.create_operation(data.design.difflist);
      me.get_operation("ExtrusionDesignOperation").data =
        data.design.difflist[1];

      if (typeof args != "undefined") {
        args["background"] = 0;
        args["depth"] = 2;
        args["use_new_texture"] = false;
        args["usecolors"] = true;
        args["enabled"] = true;
        args["color_r"] = 0.5;
        args["color_g"] = 0.5;
        args["color_b"] = 0.5;
        $.when(
          me.do_op_update(me.get_operation("TextDesignOperation").id, {
            enabled: false,
          }),
          me.do_op_update(me.get_operation("ExtrusionDesignOperation").id, args)
        ).then(function () {
          me.dfd_fetch_operation.resolve();
        });
      } else {
        me.dfd_fetch_operation.resolve();
      }
    });

    return this.dfd_fetch_operation.promise();
  },

  generate_cylinder_script: function (size, radius) {
    var script =
      '{% include "gallery/create_cone_support_cone_generation.js" %}\n';
    script +=
      "var c = create_cone([0, 0, 0]," +
      radius +
      ",[0, 0, -1]," +
      "[0, 0, " +
      size +
      "]," +
      radius +
      ",[0, 0, 1])\n";
    script += "union(c)\n";

    return script;
  },

  create_cylinder: function (script_op_id, size, radius) {
    var dfd = $.Deferred();
    this.start_editing(false).then(
      function () {
        var args = {
          id: script_op_id,
          language: "template/javascript",
          script: this.generate_cylinder_script(size, radius),
          locked_fields: "script",
          force_locked_fields: "",
          need_html: false,
        };

        this.add_operation(args).then(
          function () {
            dfd.resolve();
          }.bind(this)
        );
      }.bind(this)
    );
    return dfd.promise();
  },

  generate_cone_script: function (size, invert) {
    var script =
      '{% include "gallery/create_cone_support_cone_generation.js" %}\n';

    if (invert) {
      script += "var c = create_cone([0, 0, " + -size + "], 0, [0, 0, 1],";
      script += "[0, 0, 0], " + -size + ", [0, 0, 1])\n";
      script += "union(c)\n";
      script += "translate(0, 0, " + size + ")\n";
    } else {
      script += "var c = create_cone([0, 0, " + size + "], 0, [0, 0, 1],";
      script += "[0, 0, 0], " + size + ", [0, 0, 1])\n";
      script += "union(c)\n";
    }

    return script;
  },

  create_cone: function (script_op_id, size, invert) {
    var dfd = $.Deferred();
    this.start_editing(false).then(
      function () {
        var args = {
          id: script_op_id,
          language: "template/javascript",
          script: this.generate_cone_script(size, invert),
          locked_fields: "script",
          force_locked_fields: "",
          need_html: false,
        };

        this.add_operation(args).then(
          function () {
            dfd.resolve();
          }.bind(this)
        );
      }.bind(this)
    );
    return dfd.promise();
  },
};

function get_cursor_material() {
  return "full_a3388bb_d4499ee_s000000_e000000_t000000_x10000_i1_l0";
}

function init_cone_node(viewer, script_op_id, size, name, invert) {
  var cone_design = new Design({ empty_design: true });
  var dfd = $.Deferred();

  cone_design.create_cone(script_op_id, size, invert).then(function () {
    var cone_node = viewer.createNode(name);

    cone_design.load_in_viewer(viewer, cone_node.id).then(function () {
      dfd.cone_node = cone_node;
      dfd.resolve(cone_node);
    });
  });

  return dfd;
}

function init_cylinder_node(viewer, script_op_id, size, radius, name) {
  var cylinder_design = new Design({ empty_design: true });
  var dfd = $.Deferred();

  cylinder_design.create_cylinder(script_op_id, size, radius).then(function () {
    var cylinder_node = viewer.createNode(name);

    cylinder_design.load_in_viewer(viewer, cylinder_node.id).then(function () {
      dfd.cylinder_node = cylinder_node;
      dfd.resolve(cylinder_node);
    });
  });

  return dfd;
}

function Order(dict) {
  var _this = this;

  this.price_timer = false;
  this.date_timer = false;
  this.quantity = 1;
  this.valid = true;
  this.material_slug_to_pk = {};

  for (var k in dict) {
    this[k] = dict[k];
  }

  if (dict && dict["materials"]) {
    this.update_material_map();
  }

  this.ajax_price = new AjaxHandler({
    delay: 1000,
    start: function () {
      $.Topic("price-update-start").publish();
    },

    success: function (data) {
      _this.valid = data.error && data.error.id == 0;
      $.Topic("price-update-result").publish(data);
    },
  });
  this.ajax_delivery = new AjaxHandler({
    delay: 1000,
    start: function () {
      $.Topic("delivery-update-start").publish();
    },

    success: function (data) {
      $.Topic("delivery-update-result").publish(data);
    },
  });

  this.materials_status = 0;
  this.ajax_materials = new AjaxHandler({
    delay: 1000,
    start: function () {
      return $.Deferred();

      // $.Topic("materials-update-start").publish();
    },

    error: function (jqXHR, dfd) {
      dfd.reject(jqXHR);

      // $.Topic("materials-update-error").publish(jqXHR);
    },

    success: function (data, dfd) {
      if (!data.length) {
        dfd.reject();

        return;
      }

      var process_materials = function (data, design, materials) {
        for (var i = 0; i < data.length; i++) {
          var d = data[i];
          if ($.isEmptyObject(_this.fullSlugToMaterial)) {
            var pk = _this.material_slug_to_pk[d.material];
          } else {
            var map_name = _this.get_map_name(d.material);
            var pk = _this.fullSlugToMaterial[map_name];
          }

          if (typeof pk == "undefined") {
            continue;
          }

          var material = materials[pk];

          if (d.error) {
            delete material.unit_price;
            delete material.delivery;
            material.error = d.error;
          } else {
            delete material.error;
            material.unit_price =
              d.price.unit_price_nodiscount || d.price.unit_price;

            if (d.price.unit_price_nodiscount) {
              material.discount =
                d.price.unit_price_nodiscount - d.price.unit_price;
            } else {
              material.discount = 0;
            }

            material.no_quantity_discount = d.price.no_quantity_discount;
            if (d.delivery) {
              material.delay = d.delivery.shipped_delta;
              material.receipt_date = d.delivery.receipt_date;
              material.receipt_date_iso = d.delivery.receipt_date_iso;
              material.printer_set = d.delivery.printer_set;
              material.nb_printers = d.delivery.nb_printers;
              if (d.delivery.error && !d.error)
                material.error = d.delivery.error.text;
            }
            if (d.price.breakdown) {
              material.price_breakdown = d.price.breakdown;
            }
            if (d.num_objects) {
              material.num_objects = d.num_objects;
            }
          }

          if (d.error_info) {
            material.error_info = d.error_info;
          } else if (material.error_info) {
            delete material.error_info;
          }

          if (d.warnings) {
            material.warnings = d.warnings;
          } else {
            delete material.warnings;
          }

          if (d.warnings_list_info) {
            material.warnings_list_info = d.warnings_list_info;
          } else if (material.warnings_list_info) {
            delete material.warnings_list_info;
          }

          if (d.packing) {
            material.packing = d.packing;
          } else {
            delete material.packing;
          }

          if (d.printer) {
            material.printer = d.printer;
          } else {
            delete material.printer;
          }

          if (d.options) {
            if (material.options) {
              for (var op in material.options) {
                if (d[op] && !d[op].delivery) {
                  d[op].delivery = material.options[op].delivery;
                }
              }
            }
            material.options = d.options;
          } else {
            delete material.options;
          }

          if (d.staff_info) {
            material.staff_info = d.staff_info;
          }
          if (d.subcontractor_price) {
            material.subcontractor_price = d.subcontractor_price;
          }

          if (d.hole_threshold) {
            material.hole_threshold = d.hole_threshold;
          }

          if (d.wall_thickness) {
            material.wall_thickness = d.wall_thickness;
          }

          if ("available" in d) {
            material.available = d.available;
          }

          material.design = design;
        }
      };

      if (data[0].uuid) {
        if (_this.design.partitioning) {
          for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < _this.design.partitioning.parts.length; ++j) {
              var part = _this.design.partitioning.parts[j];

              if (part.model_uuid == data[i].uuid) {
                process_materials(data[i].price, part, part.order.materials);
                break;
              }
            }
          }

          dfd.resolve.apply(this, _this.design.partitioning.parts);
        } else {
          process_materials(data[0].price, _this.design, _this.materials);
          dfd.resolve(_this.materials);
        }
      } else {
        process_materials(data, _this.materials);
        dfd.resolve(_this.materials);
      }
    },
  });
}

Order.prototype = {
  updateMaterialList: function () {
    if (!this.design.partitioning) {
      return;
    }

    var materials = {};
    var have_one = false;

    for (var i in this.design.partitioning.parts[0].order.materials) {
      var mat = this.design.partitioning.parts[0].order.materials[i];

      // If the material is the one selected, allow it to be added to the list
      if (mat !== this.design.partitioning.parts[0].material && mat.error) {
        continue;
      }

      var all_have = true;

      for (var j = 0; j < this.design.partitioning.parts.length; ++j) {
        var part = this.design.partitioning.parts[j];

        if (!part.order.materials.hasOwnProperty(mat.id)) {
          all_have = false;
          break;
        }

        // Groups.append(part.order.material_group_manager.get_groups("remove", part));
      }

      if (all_have) {
        materials[mat.id] = $.extend({}, mat);
        have_one = true;
      }
    }

    if (have_one) {
      this.materials = materials;
      this.update_material_map();
      var not_same = false;
      var part0 = this.design.partitioning.parts[0];
      var mat = part0.material;

      for (var i = this.design.partitioning.parts.length - 1; i >= 0; i--) {
        var part = this.design.partitioning.parts[i];

        if (part.material.id != mat.id) {
          not_same = true;
          break;
        }
      }

      if (!not_same) {
        this.design.material = materials[mat.id];
      } else {
        this.design.material = null;
      }
    } else {
      this.design.material = null;
    }
  },

  has_option: function (other_opt) {
    if (!this.options) return false;
    for (var i = 0; i < this.options.length; i++) {
      var opt = this.options[i];
      if ((opt.equals && opt.equals(other_opt)) || opt == other_opt)
        return true;
    }
    return false;
  },

  get_map_name: function (material) {
    if (this.options) {
      var opt_str = "";
      var options = this.options.slice();
      options.sort();
      options.forEach(function (opt) {
        if (SITE_V1 && opt.category == "production_mode") {
          return;
        }
        opt_str += "," + opt.category + "=" + opt.key;
      });
      return material + opt_str;
    } else {
      return material;
    }
  },

  update_material_map: function () {
    this.material_slug_to_pk = {};
    this.fullSlugToMaterial = {};

    for (var k in this.materials) {
      var index = parseInt(k, 10);
      this.material_slug_to_pk[this.materials[k].slug] = index;
      var map_name = this.materials[k].map_name;
      if (map_name) {
        this.fullSlugToMaterial[map_name] = index;
      }
    }
  },

  get_material_by_slug: function (slug) {
    var id = this.material_slug_to_pk[slug];
    if (id == null || typeof id === "undefined") {
      return null;
    }
    return this.materials[id];
  },

  refreshAmount: function (theme) {
    var url = URLS["x_get_price_by_uuid_3d"] + "?quantity=" + this.quantity,
      _this = this;

    if (typeof theme === "undefined") {
      theme = false;
    }

    if (this.design.model_uuid) {
      url += "&editinfo=" + this.design.model_uuid;
    } else {
      url += "&uuid=" + this.design.design_uuid;
    }

    if (this.design.size.size_id) {
      url += "&constraintsize=" + this.design.size.size_id;
    }

    if (this.priority) {
      url += "&priority=" + this.priority;
    }

    if (this.finish) {
      url += "&finish=" + this.finish;
    }

    if (theme) {
      url += "&theme=" + theme;
    }

    this.ajax_price.add(url);
  },

  refreshDeliveryDates: function (theme) {
    var url =
      URLS["x_order_delivery_information"] + "?quantity=" + this.quantity;

    if (theme == undefined) {
      theme = false;
    }

    if (this.design.model_uuid) {
      url += "&editinfo=" + this.design.model_uuid;
    } else {
      url += "&uuid=" + this.design.design_uuid;
    }

    if (this.priority) {
      url += "&priority=" + this.priority;
    }

    if (this.finish) {
      url += "&finish=" + this.finish;
    }

    if (theme) {
      url += "&theme=" + theme;
    }

    this.ajax_delivery.add(url);
  },

  update_curreny: function (currency) {
    var _this = this;

    return $.getJSON(URLS["set_currency"] + currency).success(function (data) {
      _this.currency = currency;
      _this.currency_html = data.html_code;
    });
  },

  update_quantity: function (quantity) {
    var dfd = $.Deferred();

    new_quantity = parseInt(quantity);

    if (!isNaN(new_quantity)) {
      if (new_quantity != this.quantity) {
        this.quantity = new_quantity;
        dfd.resolve(true);
      } else {
        dfd.reject({ info: "Quantity is the same" });
      }
    } else {
      dfd.reject({ error: gettext("Quantity must be a number") });
    }

    return dfd.promise();
  },

  format_price: function (price) {
    // In cents, positive
    // consistency with server code
    return (price * 0.01).toFixed(2).replace(".", this.mon_decimal_point);
  },

  get_discounted_price: function (price, quantity) {
    // In cents, positive
    var discount = "";

    for (var i in this.quantity_discounts) {
      if (quantity >= this.quantity_discounts[i].quantity) {
        discount = this.quantity_discounts[i].discount;
      }
    }

    if (!discount) {
      return price;
    }

    var s = discount.split(".")[1];
    var exp = s.length;
    var man = parseInt(s, 10);

    if (!man) {
      return price;
    }

    var d = 1,
      e = exp;

    while (e--) {
      d *= 10;
    }

    var x = d - man; // 1 - discount
    var v = price * x;

    // Round to nearest
    v += d >> 1;
    s = String(v);

    return parseInt(s.substring(0, s.length - exp));
  },

  get_tax: function (price) {
    // In cents, positive
    if (!price) {
      return 0;
    }

    var s = this.vat.replace(".", "");
    var exp = s.length;
    var man = parseInt(s, 10);

    if (!man) {
      return 0;
    }

    var v = price * man;

    // Round to nearest
    var d = 1,
      e = exp;

    while (e--) {
      d *= 10;
    }

    v += d >> 1;
    s = String(v);

    return parseInt(s.substring(0, s.length - exp));
  },

  /**
   * Check if the material is available
   *
   * @memberof Order
   * @param {object} m - Material to check
   * @param {boolean} throw_errors - If true it will throw exceptions when and error is encountered
   * @return {boolean} - Returns true if there are no errors, false or error text otherwise
   */

  validate_material: function (m, throw_errors) {
    throw_errors = throw_errors | false;

    // Throw the first error we encounter
    if (!m) {
      if (throw_errors) {
        throw new Error(gettext("This material is currently unavailable"));
      } else {
        return false;
      }
    }

    if (m.error) {
      if (throw_errors) {
        throw new Error(m.error);
      } else {
        return m.error;
      }
    }

    if (!m.printer) {
      if (throw_errors) {
        throw new Error(gettext("This material is currently unavailable"));
      } else {
        return false;
      }
    }

    if (m.receipt_date == "n/a") {
      if (throw_errors) {
        throw new Error(gettext("This material is currently unavailable"));
      } else {
        return false;
      }
    }

    return true;
  },

  get_material_unit_price: function (m, finish, painting) {
    var parts = [this.design];

    if (this.design.partitioning) {
      parts = this.design.partitioning.parts;
    }

    var total_price = 0;

    for (var k = 0; k < parts.length; k++) {
      var part = parts[k];
      var material = part.order.materials[m.id];

      this.validate_material(material, true);

      var price = material.unit_price;

      if (price) {
        // Apply selected finish price
        finish = finish !== undefined ? finish : this.finish;
        if (finish && material.options) {
          var f = material.options["finish"][finish];

          if (f) {
            if (f.error) {
              throw new Error(f.error);
            }

            price += f.price_delta;
          }
        }

        // Apply selected painting price
        painting = painting !== undefined ? painting : this.painting;
        if (painting && material.options) {
          var f = material.options["painting"][painting];

          if (f) {
            if (f.error) {
              throw new Error(f.error);
            }

            price += f.price_delta;
          }
        }

        if (material.discount) {
          price -= material.discount;
        } else if (!material.no_quantity_discount) {
          price = this.get_discounted_price(price, this.quantity);
        }
      }

      total_price += price;
    }

    return total_price;
  },
};
